export const ListQueryKey = 'ltExchangeRecords';
export const DetailQueryKey = 'ltExchangeRecord';

export const Urls = {
  selectUrl: '/ltExchangeRecord/list',
  updateUrl: '/ltExchangeRecord/update',
};
// /api/ltExchangeRecord/list
